import LogReport from './LogReport'

export default LogReport
